import React from 'react';

import Input from '../Input';

const FileInput = (props) => (
    <Input type='file' {...props} />
);

export default FileInput;
